import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "multiple-country-states-selector-container"
  }, [_vm.form.locations.length === 0 ? [_c("div", {
    staticClass: "text-bold mb-2"
  }, [_vm._v(_vm._s(_vm.titleAll))])] : _vm._l(_vm.form.locations, function (location, index) {
    var _vm$countries$find;
    return _c("div", {
      key: "location-" + index,
      staticClass: "coutry-container"
    }, [_c("div", {
      staticClass: "flex gap-1"
    }, [_c(VAutocomplete, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        label: location.countryId ? "" : "Country",
        items: _vm.countries,
        "hide-no-data": "",
        "hide-selected": "",
        "item-text": "printable_name",
        "item-value": "id_country",
        placeholder: "Type a country name",
        filter: _vm.filterVAutocomplete
      },
      on: {
        change: function change($event) {
          return _vm.changeCountry(location);
        }
      },
      model: {
        value: location.countryId,
        callback: function callback($$v) {
          _vm.$set(location, "countryId", $$v);
        },
        expression: "location.countryId"
      }
    }), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: "",
        title: "Remove"
      },
      on: {
        click: function click($event) {
          return _vm.removeLocation(index);
        }
      }
    }, [_c("i", {
      staticClass: "fas fa-trash"
    })])], 1), ((_vm$countries$find = _vm.countries.find(function (x) {
      return x.id_country === location.countryId;
    })) === null || _vm$countries$find === void 0 || (_vm$countries$find = _vm$countries$find.states) === null || _vm$countries$find === void 0 ? void 0 : _vm$countries$find.length) > 0 ? _c(VAutocomplete, {
      staticClass: "v-text-field-no-label",
      attrs: {
        label: location.stateIds.length > 0 ? "" : "All states",
        items: _vm.countries.find(function (x) {
          return x.id_country === location.countryId;
        }).states,
        "hide-no-data": "",
        "hide-selected": "",
        "item-text": "state_label",
        "item-value": "id_state",
        clearable: "",
        multiple: "",
        chips: "",
        "deletable-chips": "",
        filter: _vm.filterVAutocomplete
      },
      on: {
        change: function change($event) {
          return _vm.valueChanged();
        }
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function fn(data) {
          return [_vm.isHorecaIncludedInUserGroup && _vm.pricePostingUsaProConstants.some(function (state) {
            return state.iso2 === data.item.iso_state;
          }) ? _c(VChip, {
            attrs: {
              close: "",
              color: "orange",
              outlined: ""
            },
            on: {
              "click:close": function clickClose($event) {
                return _vm.removeStateFromArrivals(data.index);
              }
            }
          }, [_vm._v(" " + _vm._s(data.item.state_label) + " ")]) : _c(VChip, {
            attrs: {
              close: ""
            },
            on: {
              "click:close": function clickClose($event) {
                return _vm.removeStateFromArrivals(data.index);
              }
            }
          }, [_vm._v(" " + _vm._s(data.item.state_label) + " ")])];
        }
      }], null, true),
      model: {
        value: location.stateIds,
        callback: function callback($$v) {
          _vm.$set(location, "stateIds", $$v);
        },
        expression: "location.stateIds"
      }
    }) : _vm._e()], 1);
  }), _vm.isHorecaIncludedInUserGroup && _vm.containsForbiddenStates && _vm.form.locations.length > 0 ? _c("section", {
    staticClass: "price-posting-warnings mt-2 mb-4"
  }, [_c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      text: "",
      type: "warning",
      color: "orange"
    }
  }, [_vm._v(" Due to regulations around pricing disclosure in the United States, certain states are excluded from processing. Please check your selections. ")])], 1) : _vm._e(), !_vm.disabled ? _c("div", {
    staticClass: "flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.addLocation();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" Add ")])], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };